import { SpreadsheetsProcessingStatus_Enum } from '../../../../gql-generated/hasura/graphql';

export function isProcessingCompleteOrFailed(processingStatus: SpreadsheetsProcessingStatus_Enum) {
  return (
    processingStatus === SpreadsheetsProcessingStatus_Enum.Completed ||
    processingStatus === SpreadsheetsProcessingStatus_Enum.Failed
  );
}
